import api from '@/api/axiosApi'

export interface RetailPricingItem {
  id: string
  country_code: string
  country_label: string
  currency_code: string
  retail_price: number
  landed_cost: number | null
  imu_pct: number | null
  notes: string | null
}

export interface RetailPricingResponse {
  us_final_retail: number | null
  items: RetailPricingItem[]
}

export interface RetailPricingItemInput {
  country_code: string
  currency_code: string
  retail_price: number
  landed_cost?: number | null
  notes?: string | null
}

export interface SaveRetailPricingRequest {
  items: RetailPricingItemInput[]
}

export interface BulkApplyPricingRequest {
  line_ids: string[]
  items: RetailPricingItemInput[]
}

export interface BulkApplyPricingResult {
  id: string
  success: boolean
  error: string | null
}

export interface BulkApplyPricingResponse {
  succeeded: number
  failed: number
  results: BulkApplyPricingResult[]
}

export async function fetchRetailPricing(
  planId: string,
  versionId: string,
  lineId: string
): Promise<RetailPricingResponse> {
  const response = await api.get<RetailPricingResponse>(
    `/plans/${planId}/versions/${versionId}/lines/${lineId}/retail-pricing`
  )
  return response.data
}

export async function saveRetailPricing(
  planId: string,
  versionId: string,
  lineId: string,
  body: SaveRetailPricingRequest
): Promise<RetailPricingResponse> {
  const response = await api.put<RetailPricingResponse>(
    `/plans/${planId}/versions/${versionId}/lines/${lineId}/retail-pricing`,
    body
  )
  return response.data
}

export async function deleteRetailPricing(
  planId: string,
  versionId: string,
  lineId: string
): Promise<void> {
  await api.delete(
    `/plans/${planId}/versions/${versionId}/lines/${lineId}/retail-pricing`
  )
}

export async function bulkApplyRetailPricing(
  planId: string,
  versionId: string,
  body: BulkApplyPricingRequest
): Promise<BulkApplyPricingResponse> {
  const response = await api.post<BulkApplyPricingResponse>(
    `/plans/${planId}/versions/${versionId}/retail-pricing/bulk-apply`,
    body
  )
  return response.data
}
